<template>
  <div class="site-layout">
    <!-- 搜索和添加组件 -->
    <shipment-search
        @handleAdd="handleAdd"
        @handleSearch="handleSearch"
        :title="title"
        :role="role"
        :group="group"
        :place="place"
        :search="search"
    ></shipment-search>

    <!-- 数据表格 -->
    <site-data-table
        @handleSearch="handleSearch"
        :loading="loading"
        :columns="columns"
        :data="data"
        :total="total"
        :search="search"
    >
      <template v-slot:action="action">
        <v-row justify="start">
          <!-- 编辑按钮 -->
          <v-icon color="primary" small @click="handleEdit(action.value.item)">edit</v-icon>
          <span class="table-btn-span" @click="handleEdit(action.value.item)">
                        {{ $vuetify.lang.t('$vuetify.userManage.shipment.editBtn') }}
                    </span>
          <div class="mx-1"></div>
          <!-- 删除按钮 - 仅 etone 用户可见 -->
          <v-icon
              color="primary"
              small
              @click="handleDelete(action.value.item)"
          >delete</v-icon>
          <span
              class="table-btn-span"
              @click="handleDelete(action.value.item)"
          >
                        {{ $vuetify.lang.t('$vuetify.userManage.shipment.deleteBtn') }}
                    </span>
        </v-row>
      </template>
    </site-data-table>

    <!-- 添加发货信息弹窗组件 -->
    <add-shipment
        ref="addShipment"
        :allShop="allShop"
        :allAp="allAp"
        @handleSearch="handleSearch"
    ></add-shipment>

    <!-- 编辑发货信息弹窗组件 -->
    <edit-shipment
        ref="editShipment"
        :allShop="allShop"
        :allAp="allAp"
        @handleSearch="handleSearch"
    ></edit-shipment>

    <!-- 删除确认弹窗组件 -->
    <del-shipment ref="delShipment" @handleSearch="handleSearch"></del-shipment>
  </div>
</template>

<script>
import * as api from '../../api'
import ShipmentSearch from './components/ShipmentSearch.vue'
import SiteDataTable from './components/SiteDataTable.vue'
import AddShipment from './components/AddShipment.vue'
import EditShipment from './components/EditShipment.vue'
import DelShipment from './components/DelShipment.vue'

export default {
  components: {
    ShipmentSearch,
    SiteDataTable,
    AddShipment,
    EditShipment,
    DelShipment,
  },

  data() {
    return {
      // 用户角色
      role: parseInt(window.sessionStorage.getItem('type') || 0),
      // 页面标题
      title: '发货信息管理',
      // 分组/区域数据
      group: [],
      place: [],
      // 门店列表
      allShop: [],
      // AP型号列表
      allAp: [],

      // 表格列配置
      columns: [
        {
          text: '门店',
          sortable: false,
          value: 'shop_name'
        },
        {
          text: '发货单号',
          sortable: false,
          value: 'shipment_no'
        },
        {
          text: 'AP型号',
          sortable: false,
          value: 'wifi_type'
        },
        {
          text: '数量',
          sortable: false,
          value: 'quantity'
        },
        {
          text: '发货日期',
          sortable: false,
          value: 'shipment_date'
        },
        {
          text: '计费开始日期',
          sortable: false,
          value: 'billing_start_date'
        },
        {
          text: '计费结束日期',
          sortable: false,
          value: 'billing_end_date'
        },
        {
          text: '操作',
          sortable: false,
          value: 'action'
        },
      ],

      // 表格数据
      data: [],
      // 加载状态
      loading: false,
      // 总条数
      total: 0,

      // 搜索参数
      search: {
        pagesize: 20,
        pagenum: 1,
        shop_name: null, // 门店名称搜索
        shipment_no: null, // 发货单号搜索
        wifi_type: null // AP型号搜索
      }
    }
  },

  created() {
    this.initialize()
  },

  watch: {
    $route(to, from) {
      this.search.pagenum = 1
      this.handleSearch()
    }
  },

  methods: {
    /**
     * 初始化页面数据
     */
    initialize() {
      this.getData()
      this.getAllShop()
      this.getAllAp()
    },

    /**
     * 获取门店列表
     */
    getAllShop() {
      this.$http.get(api.default.rbac.getAllShopUrl).then(resp => {
        if (!resp) return
        this.allShop = resp.data.list.map(item => ({
          value: item.id,
          label: item.shop_name
        }))
      }).catch(() => {
        this.$message.error('获取门店列表失败！')
      })
    },

    /**
     * 获取AP型号列表
     */
    getAllAp() {
      this.$http.get(api.default.rbac.getApListUrl).then(resp => {
        if (!resp) return
        this.allAp = resp.data.list.map(item => ({
          value: item.value,
          label: item.label
        }))
      }).catch(() => {
        this.$message.error('获取AP型号列表失败！')
      })
    },

    /**
     * 获取发货信息列表数据
     */
    getData() {
      this.loading = true
      this.$http.get(api.default.rbac.getShipmentListUrl, { params: this.search })
          .then(resp => {
            if (!resp || !resp.data) { // 增加空值校验
              this.$message.warning('暂无发货信息')
              return
            }
            const res = resp.data
            this.total = parseInt(res.total || 0)
            this.data = (res.list || []).map(item => ({
              id: item.id,
              shop_id: item.shop_id,
              shop_name: item.shop_name,
              ap_model_id: item.ap_model_id,
              wifi_type: item.wifi_type,
              quantity: item.quantity || '',
              shipment_no: item.shipment_no,
              shipment_date: item.shipment_date,
              shipment_detail_id: item.shipment_detail_id,
              billing_period_id: item.billing_period_id,
              billing_start_date: item.billing_start_date,
              billing_end_date: item.billing_end_date
            }))
          })
          .catch(err => {
            console.error('获取发货信息失败：', err) // 打印具体错误日志
            this.$message.error('获取发货信息失败！')
          })
          .finally(() => {
            this.loading = false
          })
    },

    /**
     * 处理添加按钮点击
     */
    handleAdd() {
      this.$refs.addShipment.handleOpen()
    },

    /**
     * 处理编辑按钮点击
     * @param {Object} item 行数据
     */
    handleEdit(item) {
      this.$refs.editShipment.handleOpen(item)
    },

    /**
     * 处理删除按钮点击
     * @param {Object} item 行数据
     */
    handleDelete(item) {
      this.$refs.delShipment.handleOpen(item)
    },

    /**
     * 处理搜索/刷新
     */
    handleSearch() {
      this.getData()
    }
  }
}
</script>

<style scoped>
.site-layout {
  margin: 0 10px;
}

.table-btn-span {
  color: #1976d2;
  cursor: pointer;
}

.mx-1 {
  margin: 0 4px;
}
</style>